module.exports = function (options) {
  var classname = options["class"] != undefined ? options["class"] : '';
  var mobileText = options.mobile_text ? "<span class=\"game-menu-icon-label\">".concat(options.mobile_text, "</span>") : '';
  return "<li id=\"".concat(options.id, "\" class=\"game-menu-icon ").concat(classname, "\">").concat(options.text).concat(mobileText, "</li>");
};